import './Checkbox.scss';

function Checkbox({ name = 'checkbox-input', checked = false,value= undefined, onChange = undefined, required = false , label = undefined }) {

    const handleChange = (e) => {
        onChange(e);
    };
    return (
        <label className="checkbox-container">
            <input type="checkbox" name={name} value={value} checked={checked} onChange={handleChange} required={required} />
            <span className="checkmark"></span>
            <div className='checkmark-label'>{label}</div>
        </label>

    );
}

export default Checkbox;